import { Controller } from "@hotwired/stimulus"
import { put } from "@rails/request.js"

// Connects to data-controller="attendance" on the full-series attendance modal.
// Each occurrence row toggles its own check-in via the shared toggle_check_in
// endpoint (the row's URL already carries that day's subevent_date). After a
// toggle we update that row's marker and recompute the "attended X of N" summary.
export default class extends Controller {
  static targets = ["row", "marker", "summary"]
  static values = {
    total: Number,
    summaryTemplate: String,
  }

  // Toggle the row the clicked marker belongs to.
  toggle(event) {
    const row = event.currentTarget.closest("[data-attendance-target='row']")
    this.toggleRow(row)
  }

  async toggleRow(row) {
    if (this.busy) return
    const url = row && row.dataset.attendanceUrlValue
    if (!url) return

    this.busy = true
    this.element.classList.add("is-loading")
    try {
      const response = await put(url, { responseKind: "json" })
      const data = await response.json
      if (response.ok && data.success) {
        if (row) this.applyRow(row, data.checked_in)
        this.refreshSummary()
        if (data.message) window.displayFlashMessage("success", data.message)
      } else {
        window.displayFlashMessage("error", (data && data.message) || "Failed to update check-in")
      }
    } catch (e) {
      window.displayFlashMessage("error", "Failed to update check-in")
    } finally {
      this.busy = false
      this.element.classList.remove("is-loading")
    }
  }

  applyRow(row, checkedIn) {
    row.dataset.attendanceCheckedInValue = checkedIn
    row.classList.toggle("attendance-row--done", checkedIn)
    const marker = row.querySelector("[data-attendance-target='marker']")
    if (marker) marker.textContent = checkedIn ? "✓" : "○"
  }

  refreshSummary() {
    const attended = this.rowTargets.filter(
      (r) => r.dataset.attendanceCheckedInValue === "true"
    ).length
    if (this.hasSummaryTarget && this.hasSummaryTemplateValue) {
      this.summaryTarget.textContent = this.summaryTemplateValue
        .replace("{attended}", attended)
        .replace("{total}", this.totalValue)
    }
  }
}
